import React, { useState } from "react";
import { Typography, TextField, Button, Paper, Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Sidebar from "../user/sidebar";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    width: "400px",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
}));

function HelpForm() {
  const classes = useStyles();
  const [transactionId, setTransactionId] = useState("");
  const [issueDetails, setIssueDetails] = useState("");
  const [disputeDetails, setDisputeDetails] = useState("");

  const handleTransactionIdChange = (event) => {
    setTransactionId(event.target.value);
  };

  const handleIssueChange = (event) => {
    setIssueDetails(event.target.value);
  };

  const handleDisputeChange = (event) => {
    setDisputeDetails(event.target.value);
  };
  /**api is an example not the actual backend API.
   * send-email should or will be the backend route for sending emails
   */
  const api = "https://salama-api.onrender.com";

const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    const response = await fetch(`${api}/send-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transaction_id: transactionId,
        issue_details: issueDetails,
        dispute_details: disputeDetails,
      }),
    });

    if (response.ok) {
      // Handle successful submission, e.g., show a success message
      console.log("Form submitted successfully");
    } else {
      // Handle error, e.g., show an error message
      console.error("Form submission failed");
    }
  } catch (error) {
    console.error("An error occurred", error);
  }
};

  return (
    <Container maxWidth="xl" style={{ display: "flex" }}>
      <Sidebar />

      <Paper 
        elevation={3}
        style={{ flex: "1", padding: "2rem", minHeight: "calc(100vh - 150px)" }}
        className={classes.paper}
      >
        <Typography variant="h6" gutterBottom>
          Raise an Issue or Dispute
        </Typography>
        <form className={classes.formContainer}>
          <TextField
            label="Transaction ID or Code"
            variant="outlined"
            fullWidth
            value={transactionId}
            onChange={handleTransactionIdChange}
          />
          <TextField
            label="Issue Details"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={issueDetails}
            onChange={handleIssueChange}
          />
          <TextField
            label="Dispute Details"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={disputeDetails}
            onChange={handleDisputeChange}
          />
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButton}
            onClick={handleSubmit}
          >
            Send Email
          </Button>
        </form>
      </Paper>
    </Container>
  );
}

export default HelpForm;
